module.exports = __webpack_public_path__ + "static/bg-all-real-economy-d412604b8889fe7881a56a7e74fb6704.jpg";